export default __webpack_public_path__ + "static/media/google.78998f2b.png";